import { render, staticRenderFns } from "./UcInvoiceTypeBadgeAlt.yaml?vue&type=template&id=1178ec42&component"
import script from "./UcInvoiceTypeBadgeAlt.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceTypeBadgeAlt.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports